export { App as default } from '@guiker/background-check-ui'
